import * as THREE from "three";
import { Context } from "../core/context";
import { DBEntity, DbLine, DbMesh, FMathUtils, ViewManager } from "@/CadEngine";
import {
  DrawOperationMovePointBeforeParams,
  DrawOperationMovePointParams,
  IModifyOperation,
  ModifyOperateState,
} from "./IModifyOperation";

import { ULabel } from "@/ui/ULabel";
import { LineDimension } from "@/Dimensions/LineDimension";
import { ArcDimension } from "@/Dimensions/ArcDimension";
import { AnchorPointAux } from "@/Dimensions/AnchorPointAuxs";
import { OrthogonalAux } from "@/Dimensions/OrthogonalAux";
import { CircleAnchorPointAuxs } from "@/Dimensions/CircleAnchorPointAuxs";
import { ActiveInputType, MoveModifyReturnData } from "@/core/Parameters";
import { DimensionGroup } from "@/core/DimensionGroup";

class MoveModify implements IModifyOperation {
  private m_context: Context;
  private m_points: THREE.Vector3[] = [];
  private m_curPoint: THREE.Vector3 = new THREE.Vector3();
  private m_auxLine: THREE.Line | undefined;
  private m_selects: DBEntity[] = [];
  private m_TextLabel: ULabel;
  private m_editLines: DbLine[] = [];
  private m_editMeshs: DbMesh[] = [];
  private m_tempObjectGroup: THREE.Group = new THREE.Group();
  private m_curVector: THREE.Vector3 = new THREE.Vector3();
  private m_returnData: MoveModifyReturnData | undefined;
  private m_dimension: DimensionGroup;
  private m_activeInputType: ActiveInputType = ActiveInputType.None;
  private m_inputValue: string = "";
  private m_distanceInputValue: string = "";
  private m_angleInputValue: string = "";
  private m_blockIdAndRootIds: string[] = [];
  private m_locationObject: THREE.Line;

  constructor(context: Context) {
    this.m_context = context;
    this.m_dimension = new DimensionGroup(
      context.ViewManager,
      context.SceneManager.AuxModel
    );
    this.m_TextLabel = new ULabel(
      this.m_context.ViewManager,
      this.m_context.Dom
    );
    this.m_selects =
      this.m_context.SelectionManager.GetSelected() as DBEntity[];
    let { editLines, editMeshs } = this.m_context.ToolsManager.GetSameTypeData(
      this.m_selects
    );
    this.m_editLines = editLines;
    this.m_editMeshs = editMeshs;
    this.m_context.SceneManager.AuxModel.add(this.m_tempObjectGroup);
    this.createTempModel();
    this.m_tempObjectGroup.visible = false;
    this.m_dimension.Line.SetVaule("");
    this.m_dimension.Arc.SetVaule("");
    this.m_dimension.Line.Input.Dom.style.border = "1px solid #101010";
    this.m_dimension.Arc.Input.Dom.style.border = "1px solid #101010";
    this.m_blockIdAndRootIds = this.m_context.ToolsManager.getBlockIdAndRootIds(
      this.m_selects as DbLine[]
    );
    this.m_locationObject = context.ToolsManager.CreatedLocationLine();
  }

  OnMovePointBefore(params: DrawOperationMovePointBeforeParams): void {}
  OnMovePoint(point: DrawOperationMovePointParams): void {
    this.m_curPoint = point.point.clone();
    this.m_locationObject.position.copy(this.m_curPoint);
    let TextLabelLocation = new THREE.Vector3();
    TextLabelLocation.x = this.m_curPoint.x + this.scale * 55;
    TextLabelLocation.y = this.m_curPoint.y - this.scale * 20;
    if (this.m_points.length == 0) {
      this.m_TextLabel.SetVaule(
        "请点取第一个基点,按Esc键将退出操作",
        TextLabelLocation,
        new THREE.Vector3(1, 0, 0)
      );
    } else if (this.m_points.length == 1) {
      this.m_tempObjectGroup.visible = true;
      this.m_TextLabel.SetVaule(
        "请点取第二个基点或Enter键完成操作,按Esc键将退出操作",
        TextLabelLocation,
        new THREE.Vector3(1, 0, 0)
      );
      this.m_auxLine?.geometry.setFromPoints([
        this.m_points[0],
        this.m_curPoint,
      ]);
      this.m_auxLine?.computeLineDistances();
      this.m_curVector = this.m_curPoint.clone().sub(this.m_points[0]);
      this.updateTempModel();
      this.updateDimension();
      this.m_activeInputType = ActiveInputType.None;
      this.m_dimension.Line.Input.Dom.style.border = "1px solid #101010";
      this.m_dimension.Arc.Input.Dom.style.border = "1px solid #101010";
      this.m_inputValue = "";
    }
  }
  OnDownPoint(point: DrawOperationMovePointParams): void {
    if (this.m_points.length == 0) {
      this.m_auxLine = this.m_context.ToolsManager.CreatedAuxLine();
    }
    if (this.m_points.length == 1) {
      this.endHandle();
      this.m_context.ModifyManager.ModifyFinish(ModifyOperateState.complete);
    }
    this.m_points.push(point.point);
  }
  onKeyDown(e: KeyboardEvent): void {
    e.preventDefault();
    if (this.m_points.length == 1) {
      if (e.key === "Tab") {
        this.m_inputValue = "";
        if (this.m_activeInputType == ActiveInputType.None) {
          this.m_activeInputType = ActiveInputType.Distance;
          this.m_dimension.Line.Input.Dom.style.border = "1px solid #ffffff";
          this.m_dimension.Arc.Input.Dom.style.border = "1px solid #101010";
        } else if (this.m_activeInputType == ActiveInputType.Distance) {
          this.m_activeInputType = ActiveInputType.Angle;
          this.m_dimension.Line.Input.Dom.style.border = "1px solid #101010";
          this.m_dimension.Arc.Input.Dom.style.border = "1px solid #ffffff";
        } else if (this.m_activeInputType == ActiveInputType.Angle) {
          this.m_activeInputType = ActiveInputType.Distance;
          this.m_dimension.Line.Input.Dom.style.border = "1px solid #ffffff";
          this.m_dimension.Arc.Input.Dom.style.border = "1px solid #101010";
        }
      }
      if (e.key === "Backspace") {
        if (this.m_inputValue.length > 0) {
          this.m_inputValue = this.m_inputValue.substring(
            0,
            this.m_inputValue.length - 1
          );
        }
        if (this.m_activeInputType == ActiveInputType.Distance) {
          this.m_dimension.Line.Input.SetVaule(this.m_inputValue + " mm");
          if (this.m_inputValue) {
            this.m_distanceInputValue = this.m_inputValue;
          }
        } else if (this.m_activeInputType == ActiveInputType.Angle) {
          this.m_dimension.Arc.Input.SetVaule(this.m_inputValue + " °");
          if (this.m_inputValue) {
            this.m_angleInputValue = this.m_inputValue;
          }
        }
      } else if ((e.key >= "0" && e.key <= "9") || e.key == ".") {
        if (this.m_activeInputType == ActiveInputType.None) return;
        if (this.m_inputValue?.includes(".") && e.key == ".") return;
        this.m_inputValue += e.key;
        if (this.m_activeInputType == ActiveInputType.Distance) {
          this.m_dimension.Line.Input.SetVaule(this.m_inputValue + " mm");
          this.m_distanceInputValue = this.m_inputValue;
        } else if (this.m_activeInputType == ActiveInputType.Angle) {
          this.m_dimension.Arc.Input.SetVaule(this.m_inputValue + " °");
          this.m_angleInputValue = this.m_inputValue;
        }
      } else if (e.key == "Enter") {
        let length = parseFloat(this.m_distanceInputValue) * 0.001;
        let angle = THREE.MathUtils.degToRad(
          parseFloat(this.m_angleInputValue)
        );
        let dir = new THREE.Vector3(1, 0, 0);
        dir.applyAxisAngle(new THREE.Vector3(0, 0, 1), angle);
        dir.multiplyScalar(length);
        this.m_curVector = dir.clone();
        this.updateTempModel();
        this.endHandle();
        this.m_context.ModifyManager.ModifyFinish(ModifyOperateState.complete);
      }
    }
  }
  onKeyUp(e: KeyboardEvent): void {}

  OnZoom(camera: THREE.Camera): void {}

  Finish(operate: ModifyOperateState) {
    this.clear();
    if (operate == ModifyOperateState.complete) {
      this.m_returnData = {
        moveVector: this.m_curVector,
      };
      return this.m_returnData;
    } else if (operate == ModifyOperateState.cancel) {
      return [];
    }
  }
  OnWheel(e: WheelEvent): void {}

  onMouseMove(e?: PointerEvent): void {}

  onMouseDown(e: PointerEvent): void {
    if (e.button !== 0) return;
  }

  onMouseUp(e: PointerEvent): void {}

  private createTempModel() {
    for (let i = 0; i < this.m_editMeshs.length; i++) {
      let tempObj = this.m_context.ToolsManager.PassDbEntityCreateTempModel(
        this.m_editMeshs[i]
      );
      if (tempObj) {
        this.m_tempObjectGroup.add(tempObj);
      }
    }
    for (let i = 0; i < this.m_editLines.length; i++) {
      let tempObj = this.m_context.ToolsManager.PassDbEntityCreateTempModel(
        this.m_editLines[i]
      );
      if (tempObj) {
        this.m_tempObjectGroup.add(tempObj);
      }
    }
  }
  private updateTempModel() {
    this.m_tempObjectGroup.children.forEach((child) => {
      if (child instanceof THREE.LineSegments) {
        let ps: number[] = Array.from(child.userData.originData.points);
        for (let i = 0; i < ps.length; i += 3) {
          let vertex = new THREE.Vector3(ps[i], ps[i + 1], ps[i + 2]);
          vertex.add(this.m_curVector.clone()); // 将顶点平移到旋转后的位置
          ps[i] = vertex.x;
          ps[i + 1] = vertex.y;
          ps[i + 2] = vertex.z;
        }
        child.geometry.setAttribute(
          "position",
          new THREE.BufferAttribute(new Float32Array(ps), 3)
        );
        child.geometry.attributes.position.needsUpdate = true;
        child.geometry.computeBoundingBox();
        child.geometry.computeBoundingSphere();
      } else if (child instanceof THREE.Mesh) {
        let ps: number[] = Array.from(child.userData.originData.vertexs);
        for (let i = 0; i < ps.length; i += 3) {
          let vertex = new THREE.Vector3(ps[i], ps[i + 1], ps[i + 2]);
          vertex.add(this.m_curVector.clone()); // 将顶点平移到旋转后的位置
          ps[i] = vertex.x;
          ps[i + 1] = vertex.y;
          ps[i + 2] = vertex.z;
        }
        child.geometry.setAttribute(
          "position",
          new THREE.BufferAttribute(new Float32Array(ps), 3)
        );
        child.geometry.attributes.position.needsUpdate = true;
        child.geometry.computeBoundingBox();
        child.geometry.computeBoundingSphere();
      }
    });
  }
  private updateDimension() {
    let lineInputPosition = new THREE.Vector3();
    lineInputPosition.x = this.m_curPoint.x + this.scale * 45;
    lineInputPosition.y = this.m_curPoint.y - this.scale;

    let distance = (this.m_curPoint.distanceTo(this.m_points[0]) * 1000)
      .toFixed(2)
      .toString();
    this.m_dimension.Line.Input.SetVaule(
      distance + " mm",
      lineInputPosition,
      new THREE.Vector3(1, 0, 0)
    );
    this.m_distanceInputValue = distance;

    let arcInputPosition = new THREE.Vector3();
    arcInputPosition.x = this.m_curPoint.x + this.scale * 120;
    arcInputPosition.y = this.m_curPoint.y - this.scale;
    let xAxis = new THREE.Vector3(1, 0, 0);
    let angle: string | number = xAxis.angleTo(
      this.m_curVector.clone().normalize()
    );
    if (this.m_curVector.clone().normalize().clone().cross(xAxis).z > 0) {
      angle = Math.PI * 2 - angle;
    }
    angle = ((angle * 180) / Math.PI).toFixed(2).toString();
    this.m_dimension.Arc.Input.SetVaule(
      angle + " °",
      arcInputPosition,
      new THREE.Vector3(1, 0, 0)
    );
    this.m_angleInputValue = angle;
  }
  private clear() {
    this.m_context.ToolsManager.GroupClear(this.m_tempObjectGroup);
    this.m_context.ToolsManager.ObjectsClear([
      this.m_locationObject,
      this.m_auxLine!,
    ]);
    this.m_dimension?.dispose();
    this.m_TextLabel.dispose();
  }

  private endHandle() {
    for (let i = 0; i < this.m_blockIdAndRootIds.length; i++) {
      let blockIdAndRootId = this.m_blockIdAndRootIds[i];
      let matrix =
        this.m_context.ToolsManager.passBlockIdAndRootIdGetMatrix(
          blockIdAndRootId
        );
      if (matrix) {
        let position = new THREE.Vector3();
        let quaternion = new THREE.Quaternion();
        let scale = new THREE.Vector3();
        matrix.decompose(position, quaternion, scale);
        position.add(this.curDir);
        matrix.compose(position, quaternion, scale);
      }
    }
    this.m_context.ToolsManager.PassTempModelDataToDbEntity(
      this.m_tempObjectGroup
    );
    let keyDatas = this.m_context.ToolsManager.filterRepeatKeyData(
      this.m_tempObjectGroup
    );
    let { Lines, Meshs } = this.m_context.ModelManager;
    for (let i = 0; i < keyDatas.length; i++) {
      let key = keyDatas[i];

      if (Lines[key]) {
        this.m_context.ModelManager.updateReferencesGeometry(Lines[key].lines);
        this.m_context.ToolsManager.LinesToModel(
          Lines[key].lines,
          Lines[key].model
        );
      }
      if (Meshs[key]) {
        this.m_context.ModelManager.updateReferencesGeometry(Meshs[key].meshs);
        this.m_context.ToolsManager.MeshToModel(
          Meshs[key].meshs,
          Meshs[key].model
        );
      }
    }
  }
  private get curDir() {
    return this.m_curPoint.clone().sub(this.m_points[0]);
  }
  private get scale() {
    return this.m_context.ViewManager.ScreenModelScale;
  }
}

export { MoveModify };
